<template>
    <div id="main">
        <div class="page page-container">
            <div class="novo-tipocadastrotalhao">
                <!-- TÍTULO -->
                <h1 class="title">
                    {{ $t("tipo-cadastro-talhao") }}:
                    {{
                        !tipocadastrotalhao.idtipocadastrotalhao
                            ? $t("novo-tipo-cadastro-talhao")
                            : tipocadastrotalhao.descricao
                    }}
                </h1>

                <!-- BREADCRUMB -->
                <nav class="breadcrumb" aria-label="breadcrumbs">
                    <ul>
                        <li>
                            <a class="a-inativo">{{ $t("agro") }}</a>
                        </li>
                        <li>
                            <a class="a-inativo">{{
                                $t("agro-cadastros")
                            }}</a>
                        </li>
                        <li>
                            <a
                                @click="
                                    $router.push({ name: 'agro-tipotalhao' })
                                "
                                >{{ $t("tipo-cadastro-talhoes") }}</a
                            >
                        </li>
                        <li>
                            <a aria-current="page">{{
                                !tipocadastrotalhao.idtipocadastrotalhao
                                    ? $t("novo-tipo-cadastro-talhao")
                                    : tipocadastrotalhao.descricao
                            }}</a>
                        </li>
                    </ul>
                </nav>

                <!-- FORMULÁRIOS -->
                <div class="columns">
                    <div class="column is-2">
                        <v-input
                            :id="'codigo'"
                            ref="idtipocadastrotalhaoerpInput"
                            v-model="tipocadastrotalhao.idtipocadastrotalhaoerp"
                            placeholder="placeholder-preencha"
                            :maxlength="30"
                            title="codigo"
                            uppercase
                        />
                    </div>
                    <div class="column">
                        <v-input
                            ref="descricaoInput"
                            v-model="tipocadastrotalhao.descricao"
                            :id="'descricao'"
                            :placeholder="'descricao-do-tipo-cadastro-talhao-placeholder'"
                            :maxlength="100"
                            :title="'descricao'"
                            :msg="'msg-campo-obrigatorio'"
                            :invalid="!tipocadastrotalhao.descricao"
                            required
                            uppercase
                            :disabled="
                                (isUpdate && !permissao.update) ||
                                (!isUpdate && !permissao.create)
                            "
                        />
                    </div>

                    <div class="column is-one-fifth is-flex is-flex-centered">
                        <b-checkbox
                            type="is-primary"
                            v-model="tipocadastrotalhao.produtivo"
                            :disabled="
                                (isUpdate && !permissao.update) ||
                                (!isUpdate && !permissao.create)
                            "
                        >
                            {{ $t("produtivo") }}?
                        </b-checkbox>
                    </div>

                    <div class="column is-one-fifth is-flex is-flex-centered">
                        <b-checkbox
                            type="is-primary"
                            v-model="tipocadastrotalhao.arrendado"
                            :disabled="
                                (isUpdate && !permissao.update) ||
                                (!isUpdate && !permissao.create)
                            "
                        >
                            {{ $t("arrendado") }}?
                        </b-checkbox>
                    </div>
                </div>

                <!-- BOTÕES -->
                <div class="form-buttons">
                    <button
                        class="delete-btn"
                        type="button"
                        @click="$router.push({ name: 'agro-tipotalhao' })"
                    >
                        {{ $t("voltar") }}
                    </button>
                    <button
                        v-if="
                            ((!isUpdate && permissao.create) ||
                            (isUpdate && permissao.update)) && !tipoTalhaIntegracao
                        "
                        class="save-btn"
                        type="button"
                        @click="saveTipoCadastroTalhao()"
                        :disabled="isSaving"
                    >
                        {{ $t("salvar") }}
                        <button-loader :isSaving="isSaving" />
                    </button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import TipoCadastroTalhaoService from "@/services/TipoCadastroTalhaoService";
import TipoCadastroTalhaoValidation from "@/services/validations/TipoCadastroTalhaoValidation";

export default {
    data() {
        return {
            tipoTalhaIntegracao: this.$store.state.user.tabelasERPWebServer.includes("TIPOTALHAO"),
            service: new TipoCadastroTalhaoService(this.$http, this.$router),
            validation: new TipoCadastroTalhaoValidation(this.$root.msgs),
            isSaving: false,
            tipocadastrotalhao: { 
                idtipocadastrotalhaoerp: null,
                produtivo: false, 
                arrendado: false 
            },
            title: "",
            msgs: [],
            isUpdate: false,
        };
    },
    created() {
        if (this.$route.params.id) {
            this.isUpdate = true;
        }

        this.permissao = this.hasPermissionAccess(
            "agro",
            "agro-cadastros",
            "agro-tipotalhao"
        );
        if (!this.isUpdate && !this.permissao.create) {
            this.$router.push({
                name: "acesso-nao-permitido",
                params: { tela: "agro-tipotalhao" },
            });
        } else {
            if (this.$route.params.id && this.$route.params.id != "new") {
                this.carregarDados(this.$route.params.id);
            }
        }
    },
    mounted() {
        this.$refs.descricaoInput.$refs.typed.focus();
    },
    methods: {
        carregarDados(id) {
            this.service.find(id).then((body) => {
                if (body.content) {
                    this.tipocadastrotalhao = body.content;
                    this.title = this.tipocadastrotalhao.descricao;
                } else {
                    this.$router.push({ name: "agro-tipotalhao-new" });
                }
            });
        },
        saveTipoCadastroTalhao(redirect = this.redirectToList) {
            this.tipocadastrotalhao = this.mapTosave(this.tipocadastrotalhao);

            if (this.validation.validate(this.tipocadastrotalhao, this.$refs)) {
                this.isSaving = true;
                this.service
                    .save(this.tipocadastrotalhao)
                    .then((body) => {
                        if (body.content) {
                            let msg = "msg-tipocadastrotalhao-salva";
                            if (this.tipocadastrotalhao.id) {
                                msg = "msg-tipocadastrotalhao-edita";
                            }
                            this.tipocadastrotalhao = body.content;
                            this.$root.showMessage("success", msg);
                            redirect(2);
                        }
                        this.isSaving = false;
                    })
                    .catch((e) => {
                        if (this.$t(e.body.message)) {
                            this.$root.showMessage("error", e.body.message);
                        } else {
                            this.$root.showMessage(
                                "error",
                                "msg-problema-realizar-acao"
                            );
                        }
                        this.isSaving = false;
                    });
            } else {
                this.$root.showMessage("alert", "msg-campos-obrigatorios");
                this.isLoading = false;
            }
        },
        redirectToList(time) {
            setTimeout(() => {
                this.$router.push({
                    name: "agro-tipotalhao",
                });
            }, time * 1000 + 50);
        },
    },
};
</script>

<style lang="scss" scoped>
#main {
    padding: 0 20px;
    height: auto;
}
.page {
    position: relative;
    margin-bottom: 40px;

    .novo-tipocadastrotalhao {
        position: relative;
        width: 100%;
        margin-bottom: 20px;
        height: 100%;
        padding-top: 0;
        > h1 {
            padding-top: 20px;
            margin-bottom: 40px;
        }
    }
}

.novo-tipocadastrotalhao .center {
    width: 100%;
    left: 0;
    transform: translateX(0);
    margin: 0;
    box-sizing: border-box;
    position: initial;
    padding-bottom: 20px;
}

.form-buttons {
    right: 0;
}

@media only screen and (min-width: 760px) {
    nav.breadcrumb {
        margin-right: 410px;
    }
}

.novo-tipocadastrotalhao .form {
    // display: block;
    width: 100%;
    display: flex;
    justify-content: space-between;
    flex-wrap: wrap;
    border-radius: 2px;
    text-align: left;

    .descricao-input {
        width: 100%;
    }

    .location {
        width: 100%;
        height: auto;
        flex: 1 1 auto;
        margin-top: 20px;
        position: relative;
        min-height: 300px;
        height: auto;
        margin-bottom: 20px;

        .getlocation {
            position: absolute;
            margin-left: 0;
            bottom: -60px;
        }
    }
}
</style>